import {IconButton, Tooltip} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import React, {useCallback, useState} from "react";
import {GoToPopup} from "./GoToPopup";
import {listenWindowEvent, useEffectWithLifetime} from "../../util/Lifetime";

export function GoToButton() {
    const [isOpened, setOpened] = useState(false);

    const openGoTo = useCallback(() => setOpened(true), [setOpened]);
    const closeGoTo = useCallback(() => setOpened(false), [setOpened])

    useEffectWithLifetime(lifetime => {
        listenWindowEvent(lifetime, 'keydown', e => {
            if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
                e.preventDefault();
                openGoTo();
            }
        });
    }, [openGoTo]);


    return (
        <>
            <Tooltip title="Go to... (⌘K)">
                <IconButton color="inherit" onClick={openGoTo} aria-label="Go to">
                    <SearchIcon/>
                </IconButton>
            </Tooltip>
            <GoToPopup open={isOpened} close={closeGoTo}/>
        </>
    );
}